import { render, staticRenderFns } from "./Riskmatrixwithtable.vue?vue&type=template&id=12217035"
import script from "./Riskmatrixwithtable.vue?vue&type=script&lang=js"
export * from "./Riskmatrixwithtable.vue?vue&type=script&lang=js"
import style0 from "./Riskmatrixwithtable.vue?vue&type=style&index=0&id=12217035&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports